import React from 'react';
import aboutPic from '../assets/about.jpg';

export default function About() {
  return (
    <section id="about">
      <div className="inn">
        <div className="agrid">
          {/* Left: Animated Photo Frame */}
          <div className="reveal aframe">
            <div className="adeco" />
            <div className="abox">
              <img src={aboutPic} alt="Vikash Gautam" />
            </div>
            <div className="abadge">
              Open to<br />Opportunities
            </div>
            <div className="adeco2" />
          </div>

          {/* Right: Bio Text */}
          <div className="reveal d2">
            <div className="shdr">
              <div className="sn2">01 / About</div>
              <h2 className="st">BUILT ON<br />REAL<br />PRODUCTION</h2>
              <div className="sl2"></div>
            </div>
            
            <div className="acopy">
              <svg width="11" height="11" viewBox="0 0 12 12" style={{ marginRight: '5px' }}>
                <circle cx="6" cy="6" r="5" stroke="var(--accent-color)" strokeWidth="1" fill="none" />
                <text x="6" y="9.5" textAnchor="middle" fontSize="7" fill="var(--accent-color)" fontFamily="serif">©</text>
              </svg>
              Govt. of India Copyright · Reg. No: L-151429/2024
            </div>

            <div className="atext">
              <p>I'm <strong>Vikash Gautam</strong>- Full Stack + Backend + AI/ML developer, currently working at <strong>Royals Webtech Pvt. Ltd.</strong> where I ship real applications used by thousands in government and private organisations.</p>
              <p>I coordinated requirements across 4+ client projects- running demos, gathering feedback, and iterating rapidly. I understand what a product needs far beyond just the code.</p>
              <p>I hold a <strong>Government of India copyright</strong> (Reg. No: L-151429/2024) for AI-based image forgery detection, backed by <strong>3 published research papers</strong> in Computer Vision and NLP. Currently co-founding <strong>CareerOS</strong> — an open-source AI career platform with 7 active contributors.</p>
            </div>

            <div className="tagrow">
              <span className="tg">Production Apps</span>
              <span className="tg">Client Communication</span>
              <span className="tg">AI Research</span>
              <span className="tg">Clean Architecture</span>
              <span className="gbadge">Open Source Founder · 7 Contributors</span>
              <span className="gbadge">GATE 2026- DS&amp;AI · AIR 12,757</span>
              {/* <span className="gbadge">GATE 2026- CS&amp;IT · Qualified</span> */}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
